import request from 'utils/request';
import configs from 'configs';

const { notificationServiceUrl } = configs;

export async function getNotifications(params) {
  return request({
    url: `${notificationServiceUrl}/notifications`,
    method: 'get',
    data: params,
  });
}

export async function countUnreadNotification(params) {
  return request({
    url: `${notificationServiceUrl}/notifications/unread`,
    method: 'get',
    data: params,
  });
}

export async function countUnreadAllSpaces(params) {
  return request({
    url: `${notificationServiceUrl}/notifications/allspaces-unread`,
    method: 'get',
    data: params,
  });
}

export async function updateNotification(params) {
  return request({
    url: `${notificationServiceUrl}/notifications/${params.id}`,
    method: 'put',
    data: params,
  });
}

export async function getActivities(params) {
  return request({
    url: `${notificationServiceUrl}/activities`,
    method: 'get',
    data: params,
  });
}

export async function updateNotifications(params) {
  return request({
    url: `${notificationServiceUrl}/notifications`,
    method: 'put',
    data: params,
  });
}

export async function notify(params) {
  return request({
    url: '/notify/',
    method: 'post',
    data: params,
  });
}



// WEBPACK FOOTER //
// ./src/services/notification.js